import React, { useEffect, useCallback, useRef, useState } from 'react';
import Button from "react-bootstrap/Button";
import { useDropzone } from 'react-dropzone';
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import { s3Link } from '../../utils/constants';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';

const headers = [
    { label: "User Login", key: "login" },
    { label: "Email", key: "email" }
];

const SubscribersEmailActions = (props) => {
    const { addToast } = useToasts();
    const [data, setData] = useState([]);
    const [isSending, setSending] = useState(false);
    const [isTestSending, setTestSending] = useState(false);
    const [isGenerating, setGenerating] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isDownload, setIsDownload] = useState(false);

    const csvLink = useRef(null);

    const dispatch = useDispatch();

    const {
        handleEmailForm,
        emailForm,
        subscriberForm,
        editorRef,
        selectedTemplate,
        setSelectedTemplate,
    } = props;

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: (images) => onDrop(images) });

    const onDrop = useCallback((images) => {
        const curr_images = images;
        const formData = new FormData();

        images.forEach((file) => {
            curr_images.push(file);
            formData.append('files[]', file);
        });

        axios({
            method: 'post',
            url: '/api/stash-upload-email',
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((data) => {
                console.log(data.data);
                console.log(data.data.file_url);
                setFileUrl(`${s3Link}/${data.data.file_url}`);
            })
            .catch((data) => {
                console.log('error');
                // handle error
            });
    }, []);

    const handleClose = () => {
        setShowModal(false);
    };

    const handleDownload = () => {
        setGenerating(true);
        if (!subscriberForm.puid) {
            setGenerating(false);
            return addToast('PU ID is required', { appearance: 'error', autoDismiss: true });
        }

        axios.post('/api/administration/generate-list', subscriberForm)
            .then(res => {
                const subscribers = res.data.subscribers;
                setData(subscribers);
                setGenerating(false);
                setShowModal(true);
            }).catch(err => {
                console.log(err);
                setGenerating(false);
                addToast('Unable to generate list of subscribers!', { appearance: 'error', autoDismiss: true });
            });
    };

    const handleSendTest = () => {
        setTestSending(true);
        axios.post('/api/administration/test-email', {
            email: emailForm.test,
            content: editorRef.current ? editorRef.current.getContent() : '<p></p>',
            subject: emailForm.subject
        }).then(res => {
            addToast('Successfully sent test email!', { appearance: 'success', autoDismiss: true });
            setTestSending(false);
        }).catch(err => {
            const error = err.response;
            if (error.status == 422) {
                setTestSending(false);
                return addToast(error.data.errors.email[0], { appearance: 'error', autoDismiss: true });
            }
            setTestSending(false);
            addToast('Unable to send test email!', { appearance: 'error', autoDismiss: true });
        });
    };

    const handleSubmitToSubscribers = () => {
        setSending(true);
        axios.post('/api/administration/submit-email', {
            puid: subscriberForm.puid,
            registered_date: subscriberForm.SuRegisteredDate,
            min_pay: subscriberForm.minPay,
            max_subs: subscriberForm.maxSubscribers,
            template: selectedTemplate,
            content: editorRef.current ? editorRef.current.getContent() : '<p></p>',
            subject: emailForm.subject
        }).then(response => {
            setSelectedTemplate(response.data.template);
            dispatch(setAlert({
                show: true,
                title: '',
                body: 'Sending of emails successfully added to queue',
                type: 'success'
            }));
            // addToast('Sending of emails successfully added to queue', { appearance: 'success', autoDismiss: true });
            setSending(false);
        }).catch(err => {
            handleErrorToast(err);
        });
    };

    const handleErrorToast = (err) => {
        const requiredParams = ['subject', 'puid', 'registered_date', 'min_pay', 'max_subs'];
        const error = err.response.data;
        if (err.response.status == 422) {
            requiredParams.forEach((item) => {
                if (item in error.errors) {
                    addToast(error.errors[item][0], { appearance: 'error', autoDismiss: true });
                }
            });
            return setSending(false);
        } else {
            console.log(err);
            addToast('Unable to send email!', { appearance: 'error', autoDismiss: true });
        }
        setSending(false);
    };

    useEffect(() => {
        if (data.length > 0 && isDownload) {
            setTimeout(() => csvLink.current.link.click(), 0);
            addToast('Successfully generated list of subscribers!', { appearance: 'success', autoDismiss: true });
            setIsDownload(false);
        }
    }, [data]);

    const handleCsvDownload = () => {
        setIsDownload(true);
        handleDownload();
    };

    return (
        <div className="d-flex flex-row align-items-end mt-1 flex-wrap">
            <CSVLink
                ref={csvLink}
                filename={`EmailXL-${moment().format('YYYY-MM-DD-hh-mm-ss')}`}
                data={data}
                headers={headers}
                asyncOnClick={true}
            />

            <Button
                className="mr-4"
                style={{ maxWidth: 320 }}
                variant="primary"
                disabled={isGenerating}
                onClick={handleDownload}
            >
                {isGenerating ? (
                    <div className="d-flex flex-row align-items-center">
                        <div className="spinner-border text-light mr-2 spinner-border-sm" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        Generating
                    </div>
                ) : (
                    'Generate List of Subscribers'
                )}
            </Button>


            <Button
                className="mr-4"
                variant="primary"
                disabled={isSending}
                onClick={handleSubmitToSubscribers}
            >
                {isSending ? (
                    <div className="d-flex flex-row align-items-center">
                        <div className="spinner-border text-light mr-2 spinner-border-sm" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        Sending
                    </div>
                ) : (
                    'Submit To All Subscribers'
                )}
            </Button>
            <div className="d-flex flex-row align-items-end">
                <div className="mr-2">
                    <p className="m-0 mr-1 mt-1">Test Email</p>
                    <input
                        type="text"
                        value={emailForm.test}
                        onChange={(e) => handleEmailForm('test', e.target.value)}
                    />
                </div>
                <div>
                    <Button
                        variant="primary"
                        onClick={handleSendTest}
                        disabled={isTestSending}
                    >
                        {isTestSending ? (
                            <div className="d-flex flex-row align-items-center">
                                <div className="spinner-border text-light mr-2 spinner-border-sm" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                Sending
                            </div>
                        ) : (
                            'Send Test'
                        )}
                    </Button>
                </div>
            </div>
            <div className="email-upload-cont mt-4">
                <div className={"stash-buttons-left stash-buttons-full stash-buttons-full-email  "}>
                    <span className="stash-upload-btn" {...getRootProps()}>                <input {...getInputProps()} />
                        {
                            isDragActive
                                ? <p>Drop the files here ...</p>
                                : <FontAwesomeIcon icon={['fas', 'photo-video']} />
                        }UPLOAD MEDIA</span>
                </div>
            </div>
            <div className="email-upload-output">
                {fileUrl &&
                    <div>File Location: {fileUrl}</div>
                }
            </div>

            <Modal
                show={showModal}
                onHide={handleClose}
                siz="md"
                scrollable={true}
            >
                <Modal.Header>
                    <Modal.Title>Generated List of Subscribers</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: 200 }}>
                    <h6 className="mb-4">Total Subscibers: {data.length}</h6>
                    <table className='table table-hover table-striped table-sm'>
                        <thead>
                            <tr>
                                <th>Login Name</th>
                                <th>Email</th>
                                <th>Subscription Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.length > 0
                                    ? data.map((subscriber, index) => {
                                        return <tr key={`subscriber-${index}`}>
                                            <td>{subscriber.login}</td>
                                            <td>{subscriber.email}</td>
                                            <td>
                                                {
                                                    moment.utc(subscriber.subscribed_at).local().format('ll')
                                                }
                                            </td>
                                        </tr>;
                                    })
                                    : <tr>
                                        <td colSpan={3}>No subscribers found.</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleCsvDownload}
                        disabled={isGenerating || data.length == 0}
                    >
                        {isGenerating ? 'Downloading...' : 'Download'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default SubscribersEmailActions;